/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

export const isJson = (item) => {
  item = typeof item !== 'string' ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  return typeof item === 'object' && item !== null;
};
